import * as React from "react";
import { useMemo } from "react";
import PaginatedEntityTableFilterContext from "./TableFilterContext";
const noop = () => {
};
const TableFilterProvider = ({ children = void 0, externalSearch = void 0, value }) => {
  const contextValue = useMemo(() => {
    if (!externalSearch) {
      return value;
    }
    return {
      ...value,
      searchParams: {
        ...value.searchParams,
        query: externalSearch.query
      },
      setQuery: noop
    };
  }, [externalSearch, value]);
  return /* @__PURE__ */ React.createElement(PaginatedEntityTableFilterContext.Provider, { value: contextValue }, children);
};
export default TableFilterProvider;
